import msgIcon1 from "../../../../assets/images/svg/msg_icon-1.svg";
import CustomLink from "../../../../components/Common/buttons/CustomLink";

const TAMRender = ({ notification, classes }) => (
  <div className={classes.msgItem} key={`${notification.id}-${notification.timestamp}`}>
    <img src={msgIcon1} alt="msgIcon" />
    <div className={classes.wrapText}>
      <CustomLink underlined to={`/tam/requests?id=${notification.id}`}>
        <b>{notification.name}</b>
      </CustomLink>
      <br />
      Meter Change Completed and
      <b>
        {" "}
        {notification.customerName} ({notification.customerId}){" "}
      </b>
      Requested <b>{notification.requestedAmount}</b> KES
    </div>
  </div>
);

export default TAMRender;
